import React from 'react';

const Divider = () => (
  <>
    <style>{`
      .vwp-divider {
        border: none;
        border-top: 1.5px solid #e9ecef;
        margin: 0 72px 0;
        height: 0;
        background: transparent;
      }
    `}</style>
    <hr className="vwp-divider" />
  </>
);

export default Divider; 